import { render, staticRenderFns } from "./Raport_produse_list.vue?vue&type=template&id=96cb64b6&scoped=true"
import script from "./Raport_produse_list.vue?vue&type=script&lang=js"
export * from "./Raport_produse_list.vue?vue&type=script&lang=js"
import style0 from "./Raport_produse_list.vue?vue&type=style&index=0&id=96cb64b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cb64b6",
  null
  
)

export default component.exports